import { useContext } from 'react';
import PortfolioItemContext from '../../../../../PortfolioItemContext';
import FieldContext from '../../../FieldContext';
import useFieldExternalFiles from '../useFieldExternalFiles';
import ExternalFilesContext from '@/components/FileAttachments/ExternalFilesContext';
import { type DatabaseExternalFile } from '@/lib/types';
import type React from 'react';

type TextFieldExternalFilesContextProviderProps = {
  children: React.ReactNode;
};

const TextFieldExternalFilesContextProvider = ({
  children,
}: TextFieldExternalFilesContextProviderProps) => {
  const { setPortfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);
  const field = useContext(FieldContext);

  const externalFiles = useFieldExternalFiles();

  return (
    <ExternalFilesContext.Provider
      value={{
        externalFiles,
        externalFilesExternalIds: externalFiles.map(
          externalFile => externalFile.externalFile.externalId,
        ),
        externalFilesEndpoint: `${portfolioItemApiEndpoint}/${field.id}/external-files`,
        addExternalFileToLocalState: (
          externalFile: DatabaseExternalFile,
        ): void => {
          setPortfolioItem(portfolioItem => {
            if (typeof portfolioItem.fieldValues[field.id] === 'undefined') {
              portfolioItem.fieldValues[field.id] = {
                typeSpecificValues: {},
                images: {},
                externalFiles: {},
              };
            }

            portfolioItem.fieldValues[field.id].externalFiles[externalFile.id] =
              externalFile;
          });
        },
        removeExternalFileFromLocalState: (
          externalFile: DatabaseExternalFile,
        ): void => {
          setPortfolioItem(portfolioItem => {
            delete portfolioItem.fieldValues[field.id].externalFiles[
              externalFile.id
            ];
          });
        },
      }}
    >
      {children}
    </ExternalFilesContext.Provider>
  );
};

export default TextFieldExternalFilesContextProvider;
